import * as React from "react";
function SvgReportsListening(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={122}
        cy={78}
        r={68}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={20}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={28}
        stroke="currentColor"
        d="M14 186l56-56"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReportsListening);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
